const isValidUrl = (url: string) => {
	return /^https:\/\/[^\s/$.?#].[^\s]*$/i.test(url);
};

const isSupportedHost = (urlObj: URL) => {
	return ['bitbucket.org', 'integration.bb-inf.net', 'gitlab.com', 'github.com'].includes(
		urlObj.hostname,
	);
};

const isValidRootUrl = (urlObj: URL) => {
	// Allow only /workspace/repo. Anything else is invalid
	return !urlObj.pathname.endsWith('/') && urlObj.pathname.split('/').filter(Boolean).length === 2;
};

export const isValidRepositoryUrl = (url: string) => {
	if (!isValidUrl(url)) {
		return false;
	}

	const urlObj = new URL(url);

	if (!isSupportedHost(urlObj)) {
		return false;
	}

	return isValidRootUrl(urlObj);
};
